class SyvoxExperience {
  constructor() {
    this.header = document.querySelector("[data-sx-header]");
    this.menuButton = document.querySelector("[data-sx-menu]");
    this.primaryNavigation = document.getElementById("SyvoxPrimaryNavigation");
    this.mobileMenuMedia = window.matchMedia("(max-width: 780px)");
    this.mobileMenuReturnFocus = null;
    this.mobileMenuBackgroundState = [];
    this.megaTrigger = document.querySelector("[data-sx-mega-trigger]");
    this.megaMenu = document.querySelector("[data-sx-mega-menu]");
    this.revealItems = [...document.querySelectorAll("[data-sx-reveal]")];
    this.tiltCards = [...document.querySelectorAll("[data-sx-tilt]")];
    this.tabs = [...document.querySelectorAll("[data-sx-tab]")];
    this.selectorPanel = document.querySelector("[data-sx-selector-panel]");
    this.collection = document.querySelector("[data-sx-collection]");
    this.choiceHelper = document.querySelector("[data-sx-choice-helper]");
    this.choicePrimaryButtons = [...document.querySelectorAll("[data-sx-choice-primary]")];
    this.choiceContextButtons = [...document.querySelectorAll("[data-sx-choice-context]")];
    this.choiceContextGroups = [...document.querySelectorAll("[data-sx-choice-context-group]")];
    this.choiceClear = document.querySelector("[data-sx-choice-clear]");
    this.choiceReset = document.querySelector("[data-sx-choice-reset]");
    this.availabilityToggle = document.querySelector("[data-sx-availability-toggle]");
    this.collectionCards = [...document.querySelectorAll("[data-sx-collection-card]")];
    this.collectionCount = document.querySelector("[data-sx-collection-count]");
    this.collectionGrid = document.querySelector("[data-sx-collection-grid]");
    this.collectionEmpty = document.querySelector("[data-sx-collection-empty]");
    this.collectionSort = document.querySelector("[data-sx-collection-sort]");
    this.collectionSortStatus = document.querySelector("[data-sx-collection-sort-status]");
    this.scrollLab = document.querySelector("[data-sx-scroll-lab]");
    this.productStory = document.querySelector("[data-sx-product-story]");
    this.productStages = [...document.querySelectorAll("[data-sx-product-stage]")];
    this.productGalleries = [...document.querySelectorAll("[data-sx-product-gallery]")];
    this.cartDrawer = document.querySelector("[data-sx-cart-drawer]");
    this.cartPanel = this.cartDrawer?.querySelector(".sx-cart-drawer__panel") || null;
    this.cartOpeners = [...document.querySelectorAll("[data-sx-cart-open]")];
    this.cartItems = document.querySelector("[data-sx-cart-items]");
    this.cartFooter = document.querySelector("[data-sx-cart-footer]");
    this.cartEmpty = document.querySelector("[data-sx-cart-empty]");
    this.cartLoading = document.querySelector("[data-sx-cart-loading]");
    this.cartError = document.querySelector("[data-sx-cart-error]");
    this.isNl = document.documentElement.lang.toLowerCase().startsWith("nl");
    this.cartReturnFocus = null;
    this.cartBackgroundState = [];
    this.cartImageMap = {};
    const cartImageData = document.querySelector("[data-sx-cart-images]");
    if (cartImageData) {
      try {
        this.cartImageMap = JSON.parse(cartImageData.textContent);
      } catch {
        this.cartImageMap = {};
      }
    }
    this.commerceState = {
      launchHandles: [],
      availableVariantIds: [],
    };
    const commerceStateData = document.querySelector("[data-sx-commerce-state]");
    if (commerceStateData) {
      try {
        const parsedCommerceState = JSON.parse(commerceStateData.textContent);
        this.commerceState = {
          launchHandles: Array.isArray(parsedCommerceState.launchHandles)
            ? parsedCommerceState.launchHandles
            : [],
          availableVariantIds: Array.isArray(parsedCommerceState.availableVariantIds)
            ? parsedCommerceState.availableVariantIds
            : [],
        };
      } catch {
        // Invalid or absent commerce data must never invent purchasability.
      }
    }
    this.commerceLaunchHandles = new Set(this.commerceState.launchHandles);
    this.commerceAvailableVariantIds = new Set(
      this.commerceState.availableVariantIds.map((variantId) => Number(variantId)),
    );
    this.commerceValidationStates = new Map(
      [...this.commerceAvailableVariantIds].map((variantId) => [variantId, "available"]),
    );
    this.disabledCrossSellVariants = new Set();
    this.crossSellPairs = this.readCrossSellPairs();
    this.maxCrossSellRecommendations = 1;
    this.lastAddedSourceHandle = "";
    this.lastAddedSourceVariantId = 0;
    this._lastCart = null;
    this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    this.selectorData = {
      phone: {
        series: "Essential Series",
        title: "A compact backup for everyday.",
        text: "Made for your phone, earbuds and daily commute. Easy to carry, with the charging cable kept close at hand.",
        watts: "Everyday",
        metrics: ["Easy to carry", "Phone & earbuds", "Cable kept close"],
      },
      laptop: {
        series: "Ultra Series",
        title: "A complete charging setup.",
        text: "Use the 65W charging kit with a compatible USB-C laptop at a wall socket, and choose the Magnetic 20K when you want more reserve for smaller devices.",
        watts: "More reserve",
        metrics: ["65W wall charging", "Long 2m cable", "Clear product details"],
      },
      creator: {
        series: "Elite Series",
        title: "The most extensive cable specifications.",
        text: "Compare the supported power, data and display specifications with your laptop, dock and charger before choosing.",
        watts: "Advanced",
        metrics: ["Power specifications", "Data specifications", "Compatibility first"],
      },
    };

    this.init();
  }

  isCommerceAvailableItem(item) {
    if (!item || !this.commerceLaunchHandles.has(item.handle)) return false;
    const variantId = Number(item.variant_id || item.id || 0);
    return variantId > 0 && this.commerceAvailableVariantIds.has(variantId);
  }

  commerceStatusMessageForItem(item) {
    if (!item || !this.commerceLaunchHandles.has(item.handle)) {
      return this.isNl
        ? "Niet beschikbaar in de huidige collectie"
        : "Not available in the current collection";
    }
    const variantId = Number(item.variant_id || item.id || 0);
    const validationState = this.commerceValidationStates.get(variantId);
    if (validationState === "unknown") {
      return this.isNl
        ? "Voorraad kon niet worden bevestigd"
        : "Stock could not be confirmed";
    }
    return this.isNl
      ? "Tijdelijk uitverkocht"
      : "Temporarily sold out";
  }

  cartHasUnavailableCommerce(cart) {
    return Array.isArray(cart?.items)
      && cart.items.some((item) => !this.isCommerceAvailableItem(item));
  }

  commerceBlockedMessage() {
    return this.isNl
      ? "Dit product is tijdelijk uitverkocht."
      : "This product is temporarily sold out.";
  }

  async currentVariantAvailability(handle, variantId) {
    const normalizedHandle = typeof handle === "string" ? handle.trim() : "";
    const normalizedVariantId = Number(variantId || 0);
    if (!normalizedHandle || !normalizedVariantId) return null;

    try {
      const response = await fetch(
        `${this.cartRoot()}products/${encodeURIComponent(normalizedHandle)}.js`,
        {
          cache: "no-store",
          headers: { Accept: "application/json" },
        },
      );
      if (!response.ok) return null;
      const product = await response.json();
      const variant = Array.isArray(product?.variants)
        ? product.variants.find((entry) => Number(entry?.id || 0) === normalizedVariantId)
        : null;
      return typeof variant?.available === "boolean" ? variant.available : null;
    } catch {
      return null;
    }
  }

  async revalidateCommerceAvailability(cart) {
    const cartItems = Array.isArray(cart?.items) ? cart.items : [];
    if (!cartItems.length) return;
    const variants = new Map();
    const register = (handle, variantId) => {
      const normalizedHandle = typeof handle === "string" ? handle.trim() : "";
      const normalizedVariantId = Number(variantId || 0);
      if (
        !normalizedHandle
        || !normalizedVariantId
        || !this.commerceLaunchHandles.has(normalizedHandle)
      ) return;
      variants.set(`${normalizedHandle}:${normalizedVariantId}`, {
        handle: normalizedHandle,
        variantId: normalizedVariantId,
      });
    };

    cartItems.forEach((item) => {
      register(item?.handle, item?.variant_id || item?.id);
    });
    const cartSources = new Set(
      cartItems.map(
        (item) => `${item?.handle || ""}:${Number(item?.variant_id || item?.id || 0)}`,
      ),
    );
    this.crossSellPairs.forEach((pair) => {
      if (cartSources.has(`${pair.sourceHandle}:${Number(pair.sourceVariantId || 0)}`)) {
        register(pair.targetHandle, pair.targetVariantId);
      }
    });

    const checks = await Promise.all(
      [...variants.values()].map(async ({ handle, variantId }) => ({
        variantId,
        available: await this.currentVariantAvailability(handle, variantId),
      })),
    );
    checks.forEach(({ variantId, available }) => {
      if (available === true) {
        this.commerceAvailableVariantIds.add(variantId);
        this.commerceValidationStates.set(variantId, "available");
      } else {
        this.commerceAvailableVariantIds.delete(variantId);
        this.commerceValidationStates.set(
          variantId,
          available === false ? "unavailable" : "unknown",
        );
      }
    });
  }

  readCrossSellPairs() {
    const node = document.querySelector("[data-sx-cross-sell-map]");
    if (!node) return [];

    try {
      const payload = JSON.parse(node.textContent || "{}");
      if (payload?.schemaVersion !== 2 || !Array.isArray(payload.pairs)) return [];

      const seenSources = new Set();
      return payload.pairs.filter((pair) => {
        const sourceHandle = typeof pair?.sourceHandle === "string" ? pair.sourceHandle : "";
        const targetHandle = typeof pair?.targetHandle === "string" ? pair.targetHandle : "";
        const recommendationId =
          typeof pair?.recommendationId === "string" ? pair.recommendationId : "";
        const evidenceId = typeof pair?.evidenceId === "string" ? pair.evidenceId : "";
        const basis = typeof pair?.basis === "string" ? pair.basis : "";
        const sourceVariantId = Number(pair?.sourceVariantId || 0);
        const targetVariantId = Number(pair?.targetVariantId || 0);
        const sourceInventory = Number(pair?.sourceInventory || 0);
        const targetInventory = Number(pair?.targetInventory || 0);
        const valid =
          recommendationId.length > 0
          && evidenceId.length > 0
          && basis.startsWith("catalogue-safe-")
          && sourceHandle.length > 0
          && targetHandle.length > 0
          && sourceHandle !== targetHandle
          && Number.isSafeInteger(sourceVariantId)
          && sourceVariantId > 0
          && Number.isSafeInteger(targetVariantId)
          && targetVariantId > 0
          && pair.sourceCommerceAvailable === true
          && pair.targetCommerceAvailable === true
          && pair.pairApproved === true
          && pair.sourceAvailable === true
          && Number.isFinite(sourceInventory)
          && sourceInventory > 0
          && pair.targetAvailable === true
          && Number.isFinite(targetInventory)
          && targetInventory > 0
          && this.commerceLaunchHandles.has(sourceHandle)
          && this.commerceLaunchHandles.has(targetHandle)
          && this.commerceAvailableVariantIds.has(sourceVariantId)
          && this.commerceAvailableVariantIds.has(targetVariantId)
          && !seenSources.has(sourceHandle);
        if (valid) seenSources.add(sourceHandle);
        return valid;
      });
    } catch {
      // Invalid, incomplete or absent pair data must produce no recommendation.
      return [];
    }
  }

  crossSellPairForSource(sourceHandle, sourceVariantId = 0) {
    const normalizedVariantId = Number(sourceVariantId || 0);
    return this.crossSellPairs.find(
      (pair) =>
        pair.sourceHandle === sourceHandle
        && (!normalizedVariantId || Number(pair.sourceVariantId) === normalizedVariantId)
        && this.commerceAvailableVariantIds.has(Number(pair.sourceVariantId))
        && this.commerceAvailableVariantIds.has(Number(pair.targetVariantId))
        && !this.disabledCrossSellVariants.has(Number(pair.targetVariantId)),
    ) || null;
  }

  rememberLastAddedSource(payload) {
    const addedItems = Array.isArray(payload?.items) ? payload.items : [payload];
    const addedItem = addedItems.find((item) => item?.handle && Number(item?.variant_id || item?.id));
    if (!addedItem) return;
    this.lastAddedSourceHandle = addedItem.handle;
    this.lastAddedSourceVariantId = Number(addedItem.variant_id || addedItem.id || 0);
  }

  disableCrossSellVariant(variantId) {
    const normalizedVariantId = Number(variantId || 0);
    if (!normalizedVariantId) return;
    this.disabledCrossSellVariants.add(normalizedVariantId);
    document
      .querySelectorAll(`[data-sx-cross-sell-target-variant="${normalizedVariantId}"]`)
      .forEach((element) => {
        element.hidden = true;
        element.querySelectorAll("button, input").forEach((control) => {
          control.disabled = true;
        });
      });
    if (this._lastCart) this.renderCrossSellRecommendations(this._lastCart);
  }

  init() {
    requestAnimationFrame(() => document.documentElement.classList.add("is-loaded"));
    this.setupHeader();
    this.setupMegaMenu();
    this.setupReveal();
    this.setupTilt();
    this.setupTabs();
    this.setupCollectionFilters();
    this.setupScrollLab();
    this.setupProductStory();
    this.setupNewsletterCelebration();
    this.setupProductStages();
    this.setupProductGalleries();
    this.setupVideoToggles();
    this.setupCartDrawer();
    this.setupLocalizedPolicyLinks();
  }

  setupLocalizedPolicyLinks() {
    if (!this.isNl) return;

    const rewritePrivacyLink = (root) => {
      if (!(root instanceof Element || root instanceof Document)) return;
      root.querySelectorAll('a[href]').forEach((link) => {
        const target = new URL(link.href, window.location.origin);
        if (
          target.origin === window.location.origin
          && target.pathname === "/nl/policies/privacy-policy"
        ) {
          target.pathname = "/policies/privacy-policy";
          link.href = target.href;
        }
      });
    };

    rewritePrivacyLink(document);
    if (!("MutationObserver" in window) || !document.body) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) rewritePrivacyLink(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  setupHeader() {
    if (!this.header) return;

    const updateHeader = () => {
      this.header.classList.toggle("is-scrolled", window.scrollY > 12);
    };

    updateHeader();
    window.addEventListener("scroll", updateHeader, { passive: true });

    if (this.menuButton) {
      this.menuButton.addEventListener("click", () => {
        const isOpen = !this.header.classList.contains("is-menu-open");
        this.setMobileMenu(isOpen, { moveFocus: isOpen });
      });

      document.addEventListener("keydown", (event) => {
        if (!this.isMobileMenuOpen()) return;

        if (event.key === "Escape") {
          event.preventDefault();
          if (this.header.classList.contains("is-mega-open")) {
            this.setMegaMenu(false);
            this.megaTrigger?.focus();
            return;
          }
          this.setMobileMenu(false, { restoreFocus: true });
          return;
        }

        if (event.key !== "Tab") return;
        const focusableElements = this.getMobileMenuFocusableElements();
        if (!focusableElements.length) {
          event.preventDefault();
          this.menuButton.focus();
          return;
        }

        const currentIndex = focusableElements.indexOf(document.activeElement);
        const nextIndex = currentIndex === -1
          ? event.shiftKey
            ? focusableElements.length - 1
            : 0
          : (currentIndex + (event.shiftKey ? -1 : 1) + focusableElements.length)
            % focusableElements.length;
        event.preventDefault();
        focusableElements[nextIndex].focus();
      });

      this.primaryNavigation?.querySelectorAll("a[href]").forEach((link) => {
        link.addEventListener("click", () => this.setMobileMenu(false, { restoreFocus: true }));
      });

      document.addEventListener("focusin", (event) => {
        if (!this.isMobileMenuOpen()) return;
        const focusableElements = this.getMobileMenuFocusableElements();
        if (focusableElements.includes(event.target)) return;
        window.requestAnimationFrame(() => {
          (focusableElements[0] || this.menuButton).focus();
        });
      });

      this.cartOpeners.forEach((opener) => {
        opener.addEventListener("click", () => this.setMobileMenu(false));
      });
      this.header.querySelectorAll(".sx-header-language .sx-language__option").forEach((option) => {
        option.addEventListener("click", () => this.setMobileMenu(false));
      });

      const syncMobileMenuViewport = () => {
        if (!this.mobileMenuMedia.matches) {
          if (this.header.classList.contains("is-menu-open")) {
            this.setMobileMenu(false);
          }
          this.primaryNavigation?.removeAttribute("aria-hidden");
          return;
        }

        const isOpen = this.header.classList.contains("is-menu-open");
        this.primaryNavigation?.setAttribute("aria-hidden", String(!isOpen));
        if (!isOpen) this.setMegaMenu(false);
      };

      syncMobileMenuViewport();
      if (typeof this.mobileMenuMedia.addEventListener === "function") {
        this.mobileMenuMedia.addEventListener("change", syncMobileMenuViewport);
      } else {
        this.mobileMenuMedia.addListener(syncMobileMenuViewport);
      }
    }
  }

  isMobileMenuOpen() {
    return Boolean(
      this.header
      && this.menuButton
      && this.mobileMenuMedia.matches
      && this.header.classList.contains("is-menu-open"),
    );
  }

  getMobileMenuFocusableElements() {
    if (!this.isMobileMenuOpen()) return [];

    const selector = [
      "a[href]",
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "[tabindex]:not([tabindex='-1'])",
    ].join(",");
    const candidates = [
      ...this.primaryNavigation.querySelectorAll(selector),
      this.menuButton,
      ...(this.header.classList.contains("is-mega-open")
        ? this.megaMenu?.querySelectorAll(selector) || []
        : []),
    ];

    return [...new Set(candidates)]
      .filter((element) => {
        if (!(element instanceof HTMLElement)) return false;
        if (element.closest("[hidden], [aria-hidden='true']")) return false;
        const style = window.getComputedStyle(element);
        return style.display !== "none"
          && style.visibility !== "hidden"
          && element.getClientRects().length > 0;
      })
      .sort((left, right) => {
        if (left === right) return 0;
        return left.compareDocumentPosition(right) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
  }

  setMobileMenuBackgroundInert(isInert) {
    if (!this.header) return;

    if (isInert) {
      if (this.mobileMenuBackgroundState.length) return;
      this.mobileMenuBackgroundState = [...document.body.children]
        .filter((element) => !element.contains(this.header) && !["SCRIPT", "STYLE"].includes(element.tagName))
        .map((element) => {
          const supportsInert = "inert" in element;
          const state = {
            element,
            supportsInert,
            inert: supportsInert ? element.inert : false,
            ariaHidden: element.getAttribute("aria-hidden"),
          };

          if (supportsInert) element.inert = true;
          else element.setAttribute("aria-hidden", "true");
          return state;
        });
      return;
    }

    this.mobileMenuBackgroundState.forEach(({ element, supportsInert, inert, ariaHidden }) => {
      if (!element.isConnected) return;
      if (supportsInert) {
        element.inert = inert;
      } else if (ariaHidden === null) {
        element.removeAttribute("aria-hidden");
      } else {
        element.setAttribute("aria-hidden", ariaHidden);
      }
    });
    this.mobileMenuBackgroundState = [];
  }

  setMobileMenu(isOpen, { moveFocus = false, restoreFocus = false } = {}) {
    if (!this.header || !this.menuButton) return;

    const shouldOpen = Boolean(isOpen && this.mobileMenuMedia.matches);
    if (shouldOpen && !this.mobileMenuReturnFocus) {
      this.mobileMenuReturnFocus = document.activeElement instanceof HTMLElement
        ? document.activeElement
        : this.menuButton;
    }

    this.header.classList.toggle("is-menu-open", shouldOpen);
    document.documentElement.classList.toggle("sx-menu-is-open", shouldOpen);
    document.body.classList.toggle("sx-menu-is-open", shouldOpen);
    this.setMobileMenuBackgroundInert(shouldOpen);
    this.primaryNavigation?.setAttribute("aria-hidden", String(!shouldOpen));
    this.menuButton.setAttribute("aria-expanded", String(shouldOpen));
    this.menuButton.setAttribute(
      "aria-label",
      shouldOpen
        ? this.menuButton.dataset.sxMenuLabelClose || (this.isNl ? "Menu sluiten" : "Close menu")
        : this.menuButton.dataset.sxMenuLabelOpen || (this.isNl ? "Menu openen" : "Open menu"),
    );

    if (!shouldOpen) {
      this.setMegaMenu(false);
      if (!this.mobileMenuMedia.matches) {
        this.primaryNavigation?.removeAttribute("aria-hidden");
      }
      const returnFocus = this.mobileMenuReturnFocus?.isConnected
        ? this.mobileMenuReturnFocus
        : this.menuButton;
      this.mobileMenuReturnFocus = null;
      if (restoreFocus) returnFocus.focus();
      return;
    }

    if (moveFocus) {
      window.requestAnimationFrame(() => {
        this.primaryNavigation
          ?.querySelector("button:not([disabled]), a[href]")
          ?.focus();
      });
    }
  }

  setMegaMenu(isOpen) {
    if (!this.header || !this.megaTrigger || !this.megaMenu) return;
    this.header.classList.toggle("is-mega-open", isOpen);
    this.megaTrigger.setAttribute("aria-expanded", String(isOpen));
    this.megaMenu.setAttribute("aria-hidden", String(!isOpen));
  }

  setupMegaMenu() {
    if (!this.header || !this.megaTrigger || !this.megaMenu) return;

    let closeTimer = 0;
    const clearCloseTimer = () => {
      if (!closeTimer) return;
      window.clearTimeout(closeTimer);
      closeTimer = 0;
    };
    const openMenu = () => {
      clearCloseTimer();
      this.setMegaMenu(true);
    };
    const closeMenu = () => {
      clearCloseTimer();
      this.setMegaMenu(false);
    };
    const queueClose = () => {
      clearCloseTimer();
      closeTimer = window.setTimeout(closeMenu, 140);
    };

    this.megaTrigger.addEventListener("click", () => {
      const isOpen = this.header.classList.contains("is-mega-open");
      this.setMegaMenu(!isOpen);
    });

    if (window.matchMedia("(pointer: fine)").matches) {
      this.megaTrigger.addEventListener("pointerenter", openMenu);
      this.megaMenu.addEventListener("pointerenter", clearCloseTimer);
      this.megaTrigger.addEventListener("pointerleave", queueClose);
      this.megaMenu.addEventListener("pointerleave", queueClose);
    }

    this.megaMenu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        closeMenu();
        this.setMobileMenu(false);
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape" || !this.header.classList.contains("is-mega-open")) return;
      closeMenu();
      this.megaTrigger.focus();
    });

    document.addEventListener("pointerdown", (event) => {
      if (!this.header.classList.contains("is-mega-open")) return;
      if (this.header.contains(event.target)) return;
      closeMenu();
    });
  }

  setupReveal() {
    if (this.prefersReducedMotion || !("IntersectionObserver" in window)) {
      this.revealItems.forEach((item) => item.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.12 },
    );

    this.revealItems.forEach((item) => observer.observe(item));
  }

  setupTilt() {
    if (this.prefersReducedMotion || !window.matchMedia("(pointer: fine)").matches) return;

    this.tiltCards.forEach((card) => {
      card.addEventListener("pointermove", (event) => {
        const bounds = card.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        card.style.setProperty("--tilt-x", `${(-y * 4).toFixed(2)}deg`);
        card.style.setProperty("--tilt-y", `${(x * 5).toFixed(2)}deg`);
      });

      card.addEventListener("pointerleave", () => {
        card.style.setProperty("--tilt-x", "0deg");
        card.style.setProperty("--tilt-y", "0deg");
      });
    });
  }

  setupTabs() {
    if (!this.tabs.length || !this.selectorPanel) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const key = tab.dataset.sxTab;
        const content = this.selectorData[key];
        if (!content) return;

        this.tabs.forEach((item) => item.setAttribute("aria-selected", String(item === tab)));
        this.tabs.forEach((item) => item.setAttribute("tabindex", item === tab ? "0" : "-1"));
        if (!this.prefersReducedMotion) {
          this.selectorPanel.animate(
            [
              { opacity: 0.4, transform: "translateY(8px)" },
              { opacity: 1, transform: "translateY(0)" },
            ],
            { duration: 280, easing: "ease-out" },
          );
        }

        const series = this.selectorPanel.querySelector("[data-sx-series]");
        const title = this.selectorPanel.querySelector("[data-sx-title]");
        const text = this.selectorPanel.querySelector("[data-sx-text]");
        const watts = this.selectorPanel.querySelector("[data-sx-watts]");
        const metrics = this.selectorPanel.querySelector("[data-sx-metrics]");

        if (series) series.textContent = content.series;
        if (title) title.textContent = content.title;
        if (text) text.textContent = content.text;
        if (watts) watts.textContent = content.watts;
        if (metrics) {
          metrics.replaceChildren(
            ...content.metrics.map((metric) => {
              const item = document.createElement("span");
              item.textContent = metric;
              return item;
            }),
          );
        }
      });
    });

    this.tabs.forEach((tab) => {
      tab.addEventListener("keydown", (event) => {
        if (!["ArrowLeft", "ArrowRight"].includes(event.key)) return;
        event.preventDefault();
        const currentIndex = this.tabs.indexOf(tab);
        const direction = event.key === "ArrowRight" ? 1 : -1;
        const nextIndex = (currentIndex + direction + this.tabs.length) % this.tabs.length;
        this.tabs[nextIndex].focus();
        this.tabs[nextIndex].click();
      });
    });
  }

  setupCollectionFilters() {
    if (!this.collection || !this.collectionCards.length) return;

    const allowedPrimary = new Set([
      "all",
      ...this.choicePrimaryButtons.map((button) => button.dataset.sxChoicePrimary),
    ]);
    const allowedSorts = this.collectionSort
      ? [...this.collectionSort.options].map((option) => option.value)
      : ["recommended"];
    const contextByValue = new Map(
      this.choiceContextButtons.map((button) => [
        button.dataset.sxChoiceContext,
        button.dataset.sxChoiceParent,
      ]),
    );
    let currentState = {
      primary: "all",
      context: "",
      availabilityOnly: false,
      sort: "recommended",
    };

    const sortCards = (sort) => {
      if (!this.collectionGrid) return;

      const cards = [...this.collectionCards].sort((a, b) => {
        const originalOrder = Number(a.dataset.order || 0) - Number(b.dataset.order || 0);
        if (sort === "title-asc" || sort === "title-desc") {
          const titleOrder = (a.dataset.title || "").localeCompare(
            b.dataset.title || "",
            this.isNl ? "nl" : "en",
            { numeric: true, sensitivity: "base" },
          );
          return sort === "title-desc" ? -titleOrder || originalOrder : titleOrder || originalOrder;
        }

        if (sort === "price-asc" || sort === "price-desc") {
          const aHasPrice = a.dataset.price !== undefined;
          const bHasPrice = b.dataset.price !== undefined;
          if (aHasPrice !== bHasPrice) return aHasPrice ? -1 : 1;
          if (aHasPrice && bHasPrice) {
            const priceOrder = Number(a.dataset.price) - Number(b.dataset.price);
            if (priceOrder) return sort === "price-desc" ? -priceOrder : priceOrder;
          }
        }

        return originalOrder;
      });

      cards.forEach((card) => this.collectionGrid.append(card));
    };

    const normalizeState = (state) => {
      const primary = allowedPrimary.has(state.primary) ? state.primary : "all";
      const requestedContext = contextByValue.get(state.context) === primary ? state.context : "";

      return {
        primary,
        context: requestedContext,
        availabilityOnly: state.availabilityOnly === true,
        sort: allowedSorts.includes(state.sort) ? state.sort : "recommended",
      };
    };

    const update = (nextState, { announceSort = false } = {}) => {
      const state = normalizeState(nextState);
      let visibleCount = 0;
      currentState = state;

      sortCards(state.sort);
      this.collectionCards.forEach((card) => {
        const matchesPrimary =
          state.primary === "all" || card.dataset.choicePrimary === state.primary;
        const matchesContext =
          state.context === "" || card.dataset.choiceContext === state.context;
        const matchesAvailability =
          !state.availabilityOnly || card.dataset.availability === "available";
        const matches = matchesPrimary && matchesContext && matchesAvailability;

        card.hidden = !matches;
        card.classList.toggle("is-visible", matches);
        if (matches) visibleCount += 1;
      });

      this.choicePrimaryButtons.forEach((button) => {
        const isActive = button.dataset.sxChoicePrimary === state.primary;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", String(isActive));
      });

      this.choiceContextGroups.forEach((group) => {
        group.hidden = group.dataset.sxChoiceContextGroup !== state.primary;
      });

      this.choiceContextButtons.forEach((button) => {
        const isActive =
          button.dataset.sxChoiceParent === state.primary
          && button.dataset.sxChoiceContext === state.context;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", String(isActive));
      });

      if (this.choiceHelper) this.choiceHelper.dataset.activeChoice = state.primary;
      if (this.choiceClear) {
        this.choiceClear.hidden =
          state.primary === "all" && state.context === "" && !state.availabilityOnly;
      }
      if (this.availabilityToggle) {
        this.availabilityToggle.checked = state.availabilityOnly;
      }
      if (this.collectionEmpty) this.collectionEmpty.hidden = visibleCount !== 0;

      if (this.collectionCount) {
        const noun = this.isNl
          ? visibleCount === 1
            ? "product"
            : "producten"
          : visibleCount === 1
            ? "product"
            : "products";
        this.collectionCount.textContent = `${visibleCount} ${noun}`;
      }

      if (this.collectionSort) {
        this.collectionSort.value = state.sort;
        if (announceSort && this.collectionSortStatus) {
          const selectedLabel = this.collectionSort.selectedOptions[0]?.textContent?.trim() || "";
          this.collectionSortStatus.textContent = this.isNl
            ? `Gesorteerd op ${selectedLabel}`
            : `Sorted by ${selectedLabel}`;
        }
      }

      return state;
    };

    const readState = () => {
      const params = new URLSearchParams(window.location.search);
      const legacyCategory = params.get("category");
      let primary = params.get("need") || "all";
      let context = params.get("fit") || "";

      if (!params.has("need") && legacyCategory) {
        if (legacyCategory === "powerbank" || legacyCategory === "cable") {
          primary = legacyCategory;
        } else if (legacyCategory === "charger" || legacyCategory === "bundle") {
          primary = "charging";
          context = legacyCategory;
        }
      }

      return normalizeState({
        primary,
        context,
        availabilityOnly: params.get("available") === "1",
        sort: params.get("sort") || "recommended",
      });
    };

    const writeState = (state) => {
      const url = new URL(window.location.href);
      url.searchParams.delete("category");
      if (state.primary === "all") url.searchParams.delete("need");
      else url.searchParams.set("need", state.primary);
      if (state.context === "") url.searchParams.delete("fit");
      else url.searchParams.set("fit", state.context);
      if (state.availabilityOnly) url.searchParams.set("available", "1");
      else url.searchParams.delete("available");
      if (state.sort === "recommended") url.searchParams.delete("sort");
      else url.searchParams.set("sort", state.sort);

      const nextUrl = `${url.pathname}${url.search}${url.hash}`;
      const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      if (nextUrl !== currentUrl) window.history.pushState({}, "", nextUrl);
    };

    const applyUserState = (state, options) => {
      const appliedState = update(state, options);
      writeState(appliedState);
      document.dispatchEvent(
        new CustomEvent("syvox:choice-helper-change", {
          detail: {
            primary: appliedState.primary,
            context: appliedState.context || null,
            availabilityOnly: appliedState.availabilityOnly,
          },
        }),
      );
    };

    this.choicePrimaryButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const requestedPrimary = button.dataset.sxChoicePrimary || "all";
        applyUserState({
          ...currentState,
          primary: currentState.primary === requestedPrimary ? "all" : requestedPrimary,
          context: "",
        });
      });
    });

    this.choiceContextButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const requestedContext = button.dataset.sxChoiceContext || "";
        applyUserState({
          ...currentState,
          context: currentState.context === requestedContext ? "" : requestedContext,
        });
      });
    });

    this.availabilityToggle?.addEventListener("change", () => {
      applyUserState({
        ...currentState,
        availabilityOnly: this.availabilityToggle.checked,
      });
    });

    const resetChoices = () => {
      applyUserState({
        ...currentState,
        primary: "all",
        context: "",
        availabilityOnly: false,
      });
    };
    this.choiceClear?.addEventListener("click", resetChoices);
    this.choiceReset?.addEventListener("click", resetChoices);

    this.collectionSort?.addEventListener("change", () => {
      const requestedSort = allowedSorts.includes(this.collectionSort.value)
        ? this.collectionSort.value
        : "recommended";
      applyUserState(
        {
          ...currentState,
          sort: requestedSort,
        },
        { announceSort: true },
      );
    });

    const initialState = readState();
    update(initialState);
    window.addEventListener("popstate", () => {
      update(readState());
    });
  }

  setupScrollLab() {
    if (!this.scrollLab) return;

    const scene = this.scrollLab.querySelector("[data-sx-scroll-scene]");
    const steps = [...this.scrollLab.querySelectorAll("[data-sx-scroll-step]")];
    const renders = [...this.scrollLab.querySelectorAll("[data-sx-scroll-render]")];
    const series = this.scrollLab.querySelector("[data-sx-scroll-series]");
    const watts = this.scrollLab.querySelector("[data-sx-scroll-watts]");
    const capacity = this.scrollLab.querySelector("[data-sx-scroll-capacity]");

    if (!scene || !steps.length || !renders.length) return;

    const activate = (step) => {
      const key = step.dataset.sxScrollStep;
      steps.forEach((item) => item.classList.toggle("is-active", item === step));
      renders.forEach((render) => {
        render.classList.toggle("is-active", render.dataset.sxScrollRender === key);
      });
      scene.dataset.active = key;
      if (series) series.textContent = step.dataset.series || "";
      if (watts) watts.textContent = step.dataset.watts || "";
      if (capacity) capacity.textContent = step.dataset.capacity || "";
    };

    activate(steps[0]);

    if (!this.prefersReducedMotion && "IntersectionObserver" in window) {
      const stepObserver = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (visible) activate(visible.target);
        },
        {
          rootMargin: "-38% 0px -38% 0px",
          threshold: [0, 0.2, 0.55, 0.8],
        },
      );

      steps.forEach((step) => stepObserver.observe(step));
    }

    if (this.prefersReducedMotion) return;

    let scrollFrame = 0;
    const updateProgress = () => {
      scrollFrame = 0;
      const bounds = this.scrollLab.getBoundingClientRect();
      const travel = Math.max(1, bounds.height - window.innerHeight);
      const progress = Math.min(1, Math.max(0, -bounds.top / travel));
      scene.style.setProperty("--sx-scroll-progress", progress.toFixed(4));
    };

    const requestProgressUpdate = () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(updateProgress);
    };

    updateProgress();
    window.addEventListener("scroll", requestProgressUpdate, { passive: true });
    window.addEventListener("resize", requestProgressUpdate, { passive: true });
  }

  setupProductStages() {
    if (!this.productStages.length || this.prefersReducedMotion) return;

    let stageFrame = 0;
    const updateStages = () => {
      stageFrame = 0;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      this.productStages.forEach((stage) => {
        const bounds = stage.getBoundingClientRect();
        const progress = Math.min(
          1,
          Math.max(0, (viewportHeight - bounds.top) / (viewportHeight + bounds.height)),
        );
        stage.style.setProperty("--sx-stage-progress", progress.toFixed(4));
      });
    };

    const requestStageUpdate = () => {
      if (stageFrame) return;
      stageFrame = window.requestAnimationFrame(updateStages);
    };

    updateStages();
    window.addEventListener("scroll", requestStageUpdate, { passive: true });
    window.addEventListener("resize", requestStageUpdate, { passive: true });

    if (!window.matchMedia("(pointer: fine)").matches) return;

    this.productStages.forEach((stage) => {
      stage.addEventListener("pointermove", (event) => {
        const bounds = stage.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        stage.style.setProperty("--sx-stage-x", `${(-y * 5).toFixed(2)}deg`);
        stage.style.setProperty("--sx-stage-y", `${(x * 7).toFixed(2)}deg`);
      });

      stage.addEventListener("pointerleave", () => {
        stage.style.setProperty("--sx-stage-x", "0deg");
        stage.style.setProperty("--sx-stage-y", "0deg");
      });
    });
  }

  setupProductGalleries() {
    this.productGalleries.forEach((gallery) => {
      const track = gallery.querySelector("[data-sx-product-gallery-track]");
      const slides = [...gallery.querySelectorAll("[data-sx-product-gallery-slide]")];
      const thumbs = [...gallery.querySelectorAll("[data-sx-gallery-thumb]")];
      const previous = gallery.querySelector("[data-sx-gallery-prev]");
      const next = gallery.querySelector("[data-sx-gallery-next]");
      const counter = gallery.querySelector("[data-sx-gallery-counter]");
      if (!track || slides.length < 2) return;

      let activeIndex = 0;
      let scrollFrame = 0;

      const update = (index, shouldScroll = true) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle("is-active", slideIndex === activeIndex);
        });
        // while the Solar studio-film slide is active, the whole viewport takes the
        // film's backdrop so nested corner radii can never show a seam
        const viewport = gallery.querySelector(".sx-product-gallery__viewport");
        if (viewport) {
          viewport.classList.toggle(
            "is-film-active",
            Boolean(slides[activeIndex]?.classList.contains("sx-product-gallery__slide--film"))
          );
        }
        thumbs.forEach((thumb, thumbIndex) => {
          const isActive = thumbIndex === activeIndex;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-pressed", String(isActive));
          if (isActive) {
            thumb.scrollIntoView({
              behavior: this.prefersReducedMotion ? "auto" : "smooth",
              block: "nearest",
              inline: "nearest",
            });
          }
        });
        if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
        if (shouldScroll) {
          slides[activeIndex].scrollIntoView({
            behavior: this.prefersReducedMotion ? "auto" : "smooth",
            block: "nearest",
            inline: "start",
          });
        }
      };

      thumbs.forEach((thumb, thumbIndex) => {
        thumb.addEventListener("click", () => update(thumbIndex));
        thumb.addEventListener("keydown", (event) => {
          if (!["ArrowLeft", "ArrowRight"].includes(event.key)) return;
          event.preventDefault();
          const direction = event.key === "ArrowRight" ? 1 : -1;
          const nextIndex = (thumbIndex + direction + thumbs.length) % thumbs.length;
          thumbs[nextIndex].focus();
          update(nextIndex);
        });
      });

      previous?.addEventListener("click", () => update(activeIndex - 1));
      next?.addEventListener("click", () => update(activeIndex + 1));

      track.addEventListener(
        "scroll",
        () => {
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => {
            const width = track.clientWidth || 1;
            const nextIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
            if (nextIndex !== activeIndex) update(nextIndex, false);
          });
        },
        { passive: true },
      );
    });
  }

  setupVideoToggles() {
    const autoplayVideos = [
      ...document.querySelectorAll("video[autoplay], video[data-sx-autoplay-video]"),
    ];
    const connection = window.navigator?.connection;
    const effectiveType = String(connection?.effectiveType || "").toLowerCase();
    const dataConstrained =
      connection?.saveData === true
      || effectiveType === "slow-2g"
      || effectiveType === "2g";
    const autoplayConstrained = this.prefersReducedMotion || dataConstrained;
    const hydrateVideoPoster = (video) => {
      const poster = video.dataset.sxPoster;
      if (!poster || video.getAttribute("poster")) return;
      video.setAttribute("poster", poster);
      delete video.dataset.sxPoster;
    };
    if (autoplayConstrained) {
      autoplayVideos.forEach((video) => {
        hydrateVideoPoster(video);
        video.autoplay = false;
        video.removeAttribute("autoplay");
        video.pause();
      });
    } else if ("IntersectionObserver" in window) {
      const requestVideoPlayback = (video) => {
        if (video.dataset.sxPlayScheduled === "true") return;
        video.dataset.sxPlayScheduled = "true";
        const playWhenReady = () => {
          delete video.dataset.sxPlayScheduled;
          if (video.dataset.sxInView !== "true" || video.dataset.sxUserPaused === "true") return;
          video.play().catch(() => video.pause());
        };

        if ("requestIdleCallback" in window) {
          window.requestIdleCallback(playWhenReady, { timeout: 1200 });
        } else {
          window.setTimeout(playWhenReady, 300);
        }
      };
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (!(video instanceof HTMLVideoElement)) return;

            if (entry.isIntersecting) {
              hydrateVideoPoster(video);
              video.dataset.sxInView = "true";
              requestVideoPlayback(video);
            } else {
              video.dataset.sxInView = "false";
              video.pause();
            }
          });
        },
        { rootMargin: "300px 0px", threshold: 0.01 },
      );
      autoplayVideos.forEach((video) => videoObserver.observe(video));
    } else {
      autoplayVideos.forEach((video) => {
        hydrateVideoPoster(video);
        video.play().catch(() => video.pause());
      });
    }

    document.querySelectorAll("[data-sx-video-toggle]").forEach((button) => {
      let video = null;
      const controlledId = button.getAttribute("aria-controls");
      if (controlledId) video = document.getElementById(controlledId);

      let scope = button.parentElement;
      while (!(video instanceof HTMLVideoElement) && scope && scope !== document.body) {
        video = scope.querySelector("video");
        scope = scope.parentElement;
      }
      if (!(video instanceof HTMLVideoElement)) return;

      if (!video.id) {
        video.id = `SyvoxVideo${Math.random().toString(36).slice(2, 9)}`;
      }
      button.setAttribute("aria-controls", video.id);

      const updateToggle = () => {
        const label = video.paused
          ? button.dataset.playLabel || (this.isNl ? "Video afspelen" : "Play video")
          : button.dataset.pauseLabel || (this.isNl ? "Video pauzeren" : "Pause video");
        const textTarget =
          button.querySelector("[data-sx-video-toggle-text]") ||
          button.querySelector("span:not([aria-hidden='true'])");

        button.setAttribute("aria-label", label);
        button.setAttribute("aria-pressed", String(!video.paused));
        if (textTarget) textTarget.textContent = label;
        else button.textContent = label;
      };

      button.addEventListener("click", async () => {
        if (video.paused) {
          hydrateVideoPoster(video);
          delete video.dataset.sxUserPaused;
          try {
            await video.play();
          } catch {
            video.pause();
          }
        } else {
          video.dataset.sxUserPaused = "true";
          video.pause();
        }
        updateToggle();
      });
      video.addEventListener("play", updateToggle);
      video.addEventListener("pause", updateToggle);
      video.addEventListener("ended", updateToggle);
      updateToggle();
    });
  }

  setupCartDrawer() {
    if (!this.cartDrawer || !this.cartItems) return;

    this.cartOpeners.forEach((opener) => {
      opener.addEventListener("click", (event) => {
        event.preventDefault();
        this.openCart(opener);
      });
    });

    document.addEventListener("click", async (event) => {
      const quickButton = event.target.closest("[data-sx-cart-quickadd]");
      if (!quickButton) return;
      event.preventDefault();
      event.stopPropagation();
      if (quickButton.dataset.sxCommerceAvailable !== "true") {
        this.showCartError(this.commerceBlockedMessage());
        if (!quickButton.closest("[data-sx-cart-drawer]")) this.openCart(quickButton, false);
        return;
      }
      const variantId = Number(quickButton.dataset.variantId || 0);
      if (!variantId || quickButton.disabled) return;
      const insideDrawer = Boolean(quickButton.closest("[data-sx-cart-drawer]"));
      const insideCartPage = Boolean(quickButton.closest(".sx-cart-quick--page"));
      const crossSellRow = quickButton.closest("[data-sx-cart-quick-item]");
      const crossSellPlacement = insideDrawer
        ? "cart_drawer"
        : insideCartPage
          ? "cart_page"
          : "";
      const crossSellHandle = crossSellRow?.dataset.handle || "";
      const crossSellSource = crossSellRow?.dataset.sxCrossSellSource || "";
      const crossSellRecommendationId = crossSellRow?.dataset.sxRecommendationId || "";
      const quickProductHandle =
        crossSellHandle
        || quickButton.dataset.sxProductHandle
        || "";
      let keepQuickDisabled = false;
      const approvedPair = crossSellPlacement
        ? this.crossSellPairForSource(crossSellSource)
        : null;
      if (
        crossSellPlacement
        && (
          !approvedPair
          || approvedPair.targetHandle !== crossSellHandle
          || Number(approvedPair.targetVariantId) !== variantId
          || approvedPair.recommendationId !== crossSellRecommendationId
        )
      ) {
        crossSellRow.hidden = true;
        return;
      }
      quickButton.disabled = true;
      quickButton.textContent = "…";
      this.hideCartError();
      try {
        const response = await fetch(`${this.cartRoot()}cart/add.js`, {
          method: "POST",
          headers: { Accept: "application/json", "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        const payload = await response.json();
        if (!response.ok) {
          const requestError = new Error(payload.description || (this.isNl ? "Dit product kon niet worden toegevoegd." : "This product could not be added."));
          requestError.status = response.status;
          throw requestError;
        }
        if (crossSellPlacement && crossSellHandle) {
          document.dispatchEvent(
            new CustomEvent("syvox:cross-sell-added", {
              detail: {
                placement: crossSellPlacement,
                product_handle: crossSellHandle,
                source_product_handle: crossSellSource,
                target_product_handle: crossSellHandle,
                variant_id: String(variantId),
                recommendation_id: crossSellRecommendationId,
              },
            }),
          );
        }
        this.rememberLastAddedSource(payload);
        const refreshedCart = await this.refreshCart({ settle: true });
        if (insideCartPage) {
          this.openCart(this.cartOpeners[0] || this.cartPanel, false);
          this.announceCartAddition(payload, refreshedCart);
          this.highlightCartItem(variantId);
          return;
        }
        this.announceCartAddition(payload, refreshedCart);
        if (!insideDrawer) this.openCart(quickButton, false);
        this.highlightCartItem(variantId);
        if (insideDrawer) {
          const nextQuickButton = this.cartDrawer?.querySelector(
            "[data-sx-cart-quick-item]:not([hidden]) [data-sx-cart-quickadd]",
          );
          const nextFocusTarget = nextQuickButton || this.cartPanel;
          nextFocusTarget?.focus({ preventScroll: true });
        }
      } catch (error) {
        let quickErrorMessage =
          error instanceof Error
            ? error.message
            : (this.isNl
              ? "Dit product kon niet worden toegevoegd."
              : "This product could not be added.");
        if (error?.status === 422 && crossSellPlacement) {
          this.disableCrossSellVariant(variantId);
        } else if (error?.status === 422) {
          const availability = await this.currentVariantAvailability(
            quickProductHandle,
            variantId,
          );
          if (availability !== true) {
            keepQuickDisabled = true;
            quickButton.dataset.sxCommerceAvailable = "false";
            quickButton.setAttribute(
              "aria-label",
              availability === false
                ? (this.isNl ? "Tijdelijk uitverkocht" : "Temporarily sold out")
                : (this.isNl ? "Ververs voor actuele voorraad" : "Refresh for current stock"),
            );
            quickErrorMessage = availability === false
              ? this.commerceBlockedMessage()
              : (this.isNl
                ? "De actuele voorraad kon niet worden bevestigd. Ververs de pagina voordat je opnieuw probeert."
                : "Current stock could not be confirmed. Refresh the page before trying again.");
          }
        }
        if (!insideDrawer) this.openCart(insideCartPage ? this.cartOpeners[0] || this.cartPanel : quickButton, false);
        this.showCartError(quickErrorMessage);
      } finally {
        quickButton.disabled = keepQuickDisabled;
        quickButton.textContent = keepQuickDisabled ? "×" : "+";
      }
    });

    this.cartDrawer.querySelectorAll("[data-sx-cart-close]").forEach((closer) => {
      closer.addEventListener("click", (event) => {
        if (closer.tagName === "A") {
          this.closeCart();
          return;
        }
        event.preventDefault();
        this.closeCart();
      });
    });

    this.cartDrawer.querySelector("[data-sx-cart-checkout]")?.addEventListener("click", (event) => {
      const checkout = event.currentTarget;
      if (!(checkout instanceof HTMLElement) || checkout.getAttribute("aria-disabled") !== "true") return;
      event.preventDefault();
      this.showCartError(this.commerceBlockedMessage());
    });

    this.cartItems.addEventListener("click", async (event) => {
      const button = event.target.closest("[data-sx-cart-action]");
      if (!button) return;

      const item = button.closest("[data-sx-cart-item]");
      const key = item?.dataset.sxCartKey;
      const quantity = Number(item?.dataset.sxCartQuantity || 0);
      const itemTitle = item?.dataset.sxCartTitle || (this.isNl ? "Product" : "Product");
      if (!key) return;

      let nextQuantity = quantity;
      const action = button.dataset.sxCartAction;
      if (action === "increase") nextQuantity += 1;
      if (action === "decrease") nextQuantity = Math.max(0, quantity - 1);
      if (action === "remove") nextQuantity = 0;

      button.disabled = true;
      item.setAttribute("aria-busy", "true");
      this.cartItems.setAttribute("aria-busy", "true");
      try {
        await this.changeCartLine(key, nextQuantity, itemTitle);
      } finally {
        item.removeAttribute("aria-busy");
        if (button.isConnected) button.disabled = false;
        this.cartItems.removeAttribute("aria-busy");
        this.focusCartAction(key, action);
      }
    });

    document.addEventListener("click", (event) => {
      const step = event.target.closest("[data-sx-qty-step]");
      if (!step) return;
      const input = step.closest("[data-sx-qty]")?.querySelector('input[name="quantity"]');
      if (!input) return;
      const next = Math.max(1, Number(input.value || 1) + Number(step.dataset.sxQtyStep || 0));
      input.value = String(next);
    });

    document.addEventListener("submit", async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;

      event.preventDefault();
      const linkedSubmitButtons = form.id
        ? [...document.querySelectorAll("[form]")].filter(
            (button) =>
              button.getAttribute("form") === form.id &&
              button.matches('button:not([type]), button[type="submit"], input[type="submit"]'),
          )
        : [];
      const submitButtons = [
        ...new Set([
          ...form.querySelectorAll('button:not([type]), button[type="submit"], input[type="submit"]'),
          ...linkedSubmitButtons,
        ]),
      ];
      const submitButton =
        event.submitter instanceof HTMLElement
          ? event.submitter
          : submitButtons[0] || null;
      const commerceApproved =
        submitButton?.dataset.sxCommerceAvailable === "true"
        || Boolean(form.querySelector('[data-sx-commerce-available="true"]'));
      if (!commerceApproved) {
        this.showCartError(this.commerceBlockedMessage());
        this.openCart(submitButton || form, false);
        return;
      }
      const originalLabels = new Map(
        submitButtons.map((button) => [
          button,
          button instanceof HTMLInputElement ? button.value : button.innerHTML,
        ]),
      );
      const setSubmitLabel = (button, label, asHtml = false) => {
        if (button instanceof HTMLInputElement) {
          button.value = label;
        } else if (asHtml) {
          button.innerHTML = label;
        } else {
          button.textContent = label;
        }
      };
      let addSucceeded = false;
      let keepSubmitDisabled = false;
      let blockedSubmitLabel = "";
      this.hideCartError();
      form.setAttribute("aria-busy", "true");
      submitButtons.forEach((button) => {
        button.disabled = true;
        setSubmitLabel(button, this.isNl ? "Toevoegen…" : "Adding…");
      });

      try {
        const formData = new FormData(form);
        const addOn = form.querySelector("[data-sx-addon-check]:checked");
        const addOnContainer = addOn?.closest("[data-sx-addon]");
        const addOnHandle = addOnContainer?.dataset.sxCrossSellHandle || "";
        const formSourceHandle =
          form.querySelector("[data-sx-product-recommendation]")?.dataset.sourceHandle
          || "";
        const addOnSource = addOnContainer?.dataset.sxCrossSellSource || formSourceHandle;
        const addOnRecommendationId = addOnContainer?.dataset.sxRecommendationId || "";
        const requestedAddOnVariantId = Number(addOn?.dataset.sxAddonVariant || 0);
        const mainVariantId = Number(formData.get("id"));
        const approvedAddOnPair = requestedAddOnVariantId
          ? this.crossSellPairForSource(addOnSource, mainVariantId)
          : null;
        const addOnVariantId =
          approvedAddOnPair
          && approvedAddOnPair.targetHandle === addOnHandle
          && Number(approvedAddOnPair.targetVariantId) === requestedAddOnVariantId
          && approvedAddOnPair.recommendationId === addOnRecommendationId
            ? requestedAddOnVariantId
            : 0;
        if (requestedAddOnVariantId && !addOnVariantId) {
          addOn.checked = false;
          addOn.disabled = true;
          if (addOnContainer) addOnContainer.hidden = true;
        }
        const mainRequestOptions = {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        };

        const mainResponse = await fetch(`${this.cartRoot()}cart/add.js`, mainRequestOptions);
        const mainPayload = await mainResponse.json();
        if (!mainResponse.ok) {
          const requestError = new Error(mainPayload.description || (this.isNl ? "Dit product kon niet worden toegevoegd." : "This product could not be added."));
          requestError.status = mainResponse.status;
          requestError.stage = "main";
          requestError.variantId = mainVariantId;
          requestError.sourceHandle = addOnSource;
          throw requestError;
        }

        this.rememberLastAddedSource(mainPayload);
        const successfulPayloads = [mainPayload];
        let addOnFailureMessage = "";

        if (addOnVariantId) {
          try {
            const addOnResponse = await fetch(`${this.cartRoot()}cart/add.js`, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: [{ id: addOnVariantId, quantity: 1 }],
              }),
            });
            const addOnPayload = await addOnResponse.json();
            if (!addOnResponse.ok) {
              const requestError = new Error(
                addOnPayload.description
                || (this.isNl ? "De aanvulling kon niet worden toegevoegd." : "The add-on could not be added."),
              );
              requestError.status = addOnResponse.status;
              throw requestError;
            }

            successfulPayloads.push(addOnPayload);
            document.dispatchEvent(
              new CustomEvent("syvox:cross-sell-added", {
                detail: {
                  placement: "product_page_addon",
                  product_handle: addOnHandle,
                  source_product_handle: addOnSource,
                  target_product_handle: addOnHandle,
                  variant_id: String(addOnVariantId),
                  recommendation_id: addOnRecommendationId,
                },
              }),
            );
          } catch (addOnError) {
            if (addOnError?.status === 422) {
              this.disableCrossSellVariant(addOnVariantId);
            }
            addOnFailureMessage = this.isNl
              ? "Het hoofdproduct is toegevoegd. De gekozen aanvulling is nu niet beschikbaar."
              : "The main product was added. The selected add-on is no longer available.";
          }
        }

        const refreshedCart = await this.refreshCart({ settle: true });
        this.announceCartAddition({ items: successfulPayloads }, refreshedCart);
        addSucceeded = true;
        this.openCart(submitButton || form, false);
        this.highlightCartItem(mainVariantId);
        if (addOnFailureMessage) this.showCartError(addOnFailureMessage);
      } catch (error) {
        let message =
          error instanceof Error
            ? error.message
            : this.isNl
              ? "Dit product kon niet worden toegevoegd."
              : "This product could not be added.";

        if (error?.status === 422 && error?.stage === "main") {
          const availability = await this.currentVariantAvailability(
            error.sourceHandle,
            error.variantId,
          );
          if (availability !== true) {
            keepSubmitDisabled = true;
            blockedSubmitLabel = availability === false
              ? (this.isNl ? "Tijdelijk uitverkocht" : "Temporarily sold out")
              : (this.isNl ? "Ververs voor beschikbaarheid" : "Refresh availability");
            submitButtons.forEach((button) => {
              button.dataset.sxCommerceAvailable = "false";
            });
            message = availability === false
              ? this.commerceBlockedMessage()
              : (this.isNl
                ? "De actuele voorraad kon niet worden bevestigd. Ververs de pagina voordat je opnieuw probeert."
                : "Current stock could not be confirmed. Refresh the page before trying again.");
          }
        }

        this.openCart(submitButton || form, false);
        await this.refreshCart();
        this.showCartError(message);
      } finally {
        form.removeAttribute("aria-busy");
        if (addSucceeded) {
          submitButtons.forEach((button) => {
            button.classList.add("is-added");
            setSubmitLabel(button, this.isNl ? "✓ Toegevoegd" : "✓ Added");
          });
          window.setTimeout(() => {
            submitButtons.forEach((button) => {
              button.classList.remove("is-added");
              setSubmitLabel(button, originalLabels.get(button) || "", true);
              button.disabled = false;
            });
          }, 1400);
        } else if (keepSubmitDisabled) {
          submitButtons.forEach((button) => {
            setSubmitLabel(button, blockedSubmitLabel);
            button.disabled = true;
          });
        } else {
          submitButtons.forEach((button) => {
            setSubmitLabel(button, originalLabels.get(button) || "", true);
            button.disabled = false;
          });
        }
      }
    });

    const productRecommendation = document.querySelector("[data-sx-product-recommendation]");
    if (productRecommendation) {
      const productForm = productRecommendation.closest('form[action*="/cart/add"]');
      const variantInput = productForm?.querySelector('[name="id"]');
      if (variantInput instanceof HTMLSelectElement) {
        const syncSelectedVariant = () => {
          const selectedOption = variantInput.selectedOptions[0];
          if (!selectedOption) return;
          const available = selectedOption.dataset.sxVariantAvailable === "true";
          const priceLabel = selectedOption.dataset.sxVariantPrice || "";
          const addLabel = variantInput.dataset.sxLabelAdd || (this.isNl ? "In winkelwagen" : "Add to cart");
          const stockLabel = variantInput.dataset.sxLabelInStock || (this.isNl ? "Op voorraad" : "In stock");
          const soldOutLabel = variantInput.dataset.sxLabelSoldOut || (this.isNl ? "Tijdelijk uitverkocht" : "Temporarily sold out");
          const price = document.querySelector(".sx-product__price");
          const stock = document.querySelector(".sx-product__concept");
          const stickyPrice = document.querySelector(".sx-sticky-atc__info span");
          const mainSubmit = productForm.querySelector(".sx-product-form__submit");
          const stickySubmit = document.querySelector(".sx-sticky-atc__btn");

          if (price) price.textContent = priceLabel;
          if (stickyPrice) stickyPrice.textContent = priceLabel;
          if (stock) stock.textContent = available ? stockLabel : soldOutLabel;

          [mainSubmit, stickySubmit].forEach((button) => {
            if (!(button instanceof HTMLButtonElement)) return;
            button.dataset.sxCommerceAvailable = String(available);
            button.disabled = !available;
            if (button === mainSubmit && available) {
              const label = document.createElement("span");
              label.textContent = addLabel;
              const buttonPrice = document.createElement("span");
              buttonPrice.className = "sx-product-form__submit-price";
              buttonPrice.textContent = priceLabel;
              button.replaceChildren(label, buttonPrice);
            } else {
              button.textContent = available ? addLabel : soldOutLabel;
            }
          });

          this.renderProductRecommendation(this._lastCart || { items: [] });
        };
        variantInput.addEventListener("change", syncSelectedVariant);
        syncSelectedVariant();
      } else {
        variantInput?.addEventListener("change", () => {
          this.renderProductRecommendation(this._lastCart || { items: [] });
        });
      }
    }
    if (productRecommendation || document.querySelector("[data-sx-cart-page-recommendation]")) {
      this.refreshCart();
    }

    document.addEventListener("keydown", (event) => {
      if (
        this.cartDrawer.hidden
        || this.cartDrawer.getAttribute("aria-hidden") === "true"
        || !this.cartDrawer.classList.contains("is-open")
      ) return;

      if (event.key === "Escape") {
        event.preventDefault();
        this.closeCart();
        return;
      }

      if (event.key !== "Tab") return;
      const focusable = this.getCartFocusableElements();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!this.cartPanel?.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  getCartFocusableElements() {
    if (!this.cartPanel) return [];

    return [
      ...this.cartPanel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [contenteditable="true"], [tabindex]:not([tabindex="-1"])',
      ),
    ].filter((element) => {
      if (!(element instanceof HTMLElement)) return false;
      if (element.tabIndex < 0) return false;
      if (element.closest("[hidden], [aria-hidden='true'], [inert]")) return false;
      const style = window.getComputedStyle(element);
      return style.display !== "none" && style.visibility !== "hidden" && element.getClientRects().length > 0;
    });
  }

  setCartBackgroundInert(isInert) {
    if (!this.cartDrawer) return;

    if (isInert) {
      if (this.cartBackgroundState.length) return;
      this.cartBackgroundState = [...document.body.children]
        .filter((element) => element !== this.cartDrawer && !["SCRIPT", "STYLE"].includes(element.tagName))
        .map((element) => {
          const supportsInert = "inert" in element;
          const state = {
            element,
            supportsInert,
            inert: supportsInert ? element.inert : false,
            ariaHidden: element.getAttribute("aria-hidden"),
          };

          if (supportsInert) element.inert = true;
          else element.setAttribute("aria-hidden", "true");
          return state;
        });
      return;
    }

    this.cartBackgroundState.forEach(({ element, supportsInert, inert, ariaHidden }) => {
      if (!element.isConnected) return;
      if (supportsInert) {
        element.inert = inert;
      } else if (ariaHidden === null) {
        element.removeAttribute("aria-hidden");
      } else {
        element.setAttribute("aria-hidden", ariaHidden);
      }
    });
    this.cartBackgroundState = [];
  }

  focusCartAction(key, action) {
    const rows = [...this.cartItems.querySelectorAll("[data-sx-cart-item]")];
    const sameRow = rows.find((row) => row.dataset.sxCartKey === key);
    const equivalent =
      sameRow?.querySelector(`[data-sx-cart-action="${action}"]`) ||
      this.cartItems.querySelector(`[data-sx-cart-action="${action}"]`) ||
      this.getCartFocusableElements()[0] ||
      this.cartPanel;

    if (equivalent instanceof HTMLElement) equivalent.focus();
  }

  cartRoot() {
    return window.Shopify?.routes?.root || "/";
  }

  openCart(trigger, refresh = true) {
    if (!this.cartDrawer || !this.cartPanel) return;
    this.cartReturnFocus = trigger || document.activeElement;
    this.setMobileMenu(false);
    this.cartDrawer.hidden = false;
    this.cartDrawer.setAttribute("aria-hidden", "false");
    this.setCartBackgroundInert(true);
    document.body.classList.add("sx-cart-is-open");
    requestAnimationFrame(() => {
      if (this.cartDrawer.getAttribute("aria-hidden") === "true") return;
      this.cartDrawer.classList.add("is-open");
      (this.getCartFocusableElements()[0] || this.cartPanel).focus({ preventScroll: true });
    });
    if (refresh) this.refreshCart();
  }

  closeCart() {
    if (!this.cartDrawer) return;
    this.cartDrawer.classList.remove("is-open");
    this.cartDrawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("sx-cart-is-open");
    this.setCartBackgroundInert(false);

    const finish = () => {
      if (!this.cartDrawer.classList.contains("is-open")) this.cartDrawer.hidden = true;
    };
    if (this.prefersReducedMotion) finish();
    else window.setTimeout(finish, 280);

    if (
      this.cartReturnFocus instanceof HTMLElement &&
      this.cartReturnFocus.isConnected &&
      !this.cartReturnFocus.hasAttribute("disabled")
    ) {
      this.cartReturnFocus.focus({ preventScroll: true });
    }
  }

  async refreshCart({ settle = false } = {}) {
    if (!this.cartDrawer) return;
    if (this.cartLoading) this.cartLoading.hidden = false;
    this.hideCartError();

    try {
      const readCart = async () => {
        const response = await fetch(`${this.cartRoot()}cart.js`, {
          headers: { Accept: "application/json" },
        });
        if (!response.ok) throw new Error(this.isNl ? "Je winkelwagen kon niet worden geladen." : "Your cart could not be loaded.");
        return response.json();
      };
      let cart = await readCart();
      if (settle) {
        await new Promise((resolve) => window.setTimeout(resolve, 70));
        try {
          cart = await readCart();
        } catch {
          /* retain the first authoritative cart read */
        }
      }
      await this.revalidateCommerceAvailability(cart);
      this.renderCart(cart);
      if (/\/cart\/?$/.test(window.location.pathname)) {
        await this.refreshCartPageSection();
        this.renderCrossSellRecommendations(cart);
      }
      return cart;
    } catch (error) {
      this.showCartError(error.message);
      return null;
    } finally {
      if (this.cartLoading) this.cartLoading.hidden = true;
    }
  }

  announceCartState(cart, prefix = "") {
    const status = this.cartDrawer?.querySelector("[data-sx-cart-status]");
    if (!status || !cart) return;
    const itemCount = Number(cart.item_count || 0);
    const parts = [
      prefix,
      this.isNl
        ? `${itemCount} ${itemCount === 1 ? "artikel" : "artikelen"} in je winkelwagen.`
        : `${itemCount} ${itemCount === 1 ? "item" : "items"} in your cart.`,
      this.isNl
        ? `Producttotaal ${this.formatMoney(cart.total_price, cart.currency)}.`
        : `Product subtotal ${this.formatMoney(cart.total_price, cart.currency)}.`,
    ].filter(Boolean);
    if (Number(cart.total_discount || 0) > 0) {
      parts.push(
        this.isNl
          ? `Je bespaart ${this.formatMoney(cart.total_discount, cart.currency)}.`
          : `You save ${this.formatMoney(cart.total_discount, cart.currency)}.`,
      );
    }
    if (Number(cart.total_price || 0) >= 5500) {
      parts.push(
        this.isNl
          ? "De grens voor gratis verzending in Nederland is bereikt."
          : "The free Netherlands shipping threshold is reached.",
      );
    }
    status.textContent = "";
    requestAnimationFrame(() => {
      status.textContent = parts.join(" ");
    });
  }

  announceCartAddition(payload, cart) {
    if (!cart) return;
    const addedItems = Array.isArray(payload?.items) ? payload.items : [payload];
    const addedItem = addedItems[0];
    const productName =
      addedItem?.product_title ||
      addedItem?.title ||
      (this.isNl ? "Product" : "Product");
    const additionMessage =
      addedItems.length > 1
        ? this.isNl
          ? `${addedItems.length} producten toegevoegd.`
          : `${addedItems.length} products added.`
        : this.isNl
          ? `${productName} toegevoegd.`
          : `${productName} added.`;
    this.announceCartState(
      cart,
      additionMessage,
    );
  }

  async refreshCartPageSection() {
    if (!/\/cart\/?$/.test(window.location.pathname)) return;
    const currentSection = document.querySelector(".sx-cart");
    if (!currentSection) return;
    const sectionWrapper = currentSection.closest(
      '.shopify-section[id^="shopify-section-"]',
    );
    const sectionId = sectionWrapper?.id.replace(/^shopify-section-/, "");
    if (!sectionId) return;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set("section_id", sectionId);
      const response = await fetch(url.toString(), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) return;
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const nextSection = parsed.querySelector(".sx-cart");
      if (nextSection) {
        currentSection.replaceWith(nextSection);
        if (this._lastCart) this.renderCrossSellRecommendations(this._lastCart);
      }
    } catch {
      /* The drawer remains authoritative if the optional cart-page refresh fails. */
    }
  }

  async changeCartLine(key, quantity, itemTitle = "") {
    this.cartDrawer?.classList.add("is-updating");
    this.hideCartError();

    try {
      const response = await fetch(`${this.cartRoot()}cart/change.js`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: key, quantity }),
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || (this.isNl ? "Je winkelwagen kon niet worden bijgewerkt." : "Your cart could not be updated."));
      this.renderCart(payload);
      const settledCart = await this.refreshCart({ settle: true });
      this.announceCartState(
        settledCart,
        quantity === 0
          ? this.isNl
            ? `${itemTitle || "Product"} verwijderd.`
            : `${itemTitle || "Product"} removed.`
          : this.isNl
            ? `Aantal voor ${itemTitle || "product"} bijgewerkt.`
            : `Quantity for ${itemTitle || "product"} updated.`,
      );
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : this.isNl
            ? "Je winkelwagen kon niet worden bijgewerkt."
            : "Your cart could not be updated.";
      await this.refreshCart();
      this.showCartError(message);
    } finally {
      this.cartDrawer?.classList.remove("is-updating");
    }
  }

  recommendationForCart(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    if (!items.length || !this.crossSellPairs.length) return null;

    const cartHandles = new Set(items.map((item) => item.handle));
    const sources = [];
    const lastAddedStillInCart = items.some(
      (item) =>
        item.handle === this.lastAddedSourceHandle
        && (
          !this.lastAddedSourceVariantId
          || Number(item.variant_id) === Number(this.lastAddedSourceVariantId)
        ),
    );
    if (this.lastAddedSourceHandle && lastAddedStillInCart) {
      sources.push({
        handle: this.lastAddedSourceHandle,
        variantId: this.lastAddedSourceVariantId,
      });
    }
    items.forEach((item) => {
      if (
        !sources.some(
          (source) =>
            source.handle === item.handle
            && Number(source.variantId) === Number(item.variant_id),
        )
      ) {
        sources.push({ handle: item.handle, variantId: Number(item.variant_id || 0) });
      }
    });

    return sources
      .map((source) => this.crossSellPairForSource(source.handle, source.variantId))
      .find(
        (pair) =>
          pair
          && !cartHandles.has(pair.targetHandle)
          && !this.disabledCrossSellVariants.has(Number(pair.targetVariantId)),
      ) || null;
  }

  crossSellPriceText(pair) {
    const parts = [pair.priceLabel || this.formatMoney(pair.priceCents)];
    if (Number(pair.benefitCents || 0) > 0 && pair.benefitLabel) {
      parts.push(
        this.isNl
          ? `actueel voordeel ${pair.benefitLabel}`
          : `current saving ${pair.benefitLabel}`,
      );
    }
    return parts.filter(Boolean).join(" · ");
  }

  applyCrossSellDataset(element, pair, placement) {
    element.dataset.sxCrossSellPlacement = placement;
    element.dataset.sxCrossSellSource = pair.sourceHandle;
    element.dataset.sxCrossSellTarget = pair.targetHandle;
    element.dataset.sxCrossSellTargetVariant = String(pair.targetVariantId);
    element.dataset.sxRecommendationId = pair.recommendationId;
  }

  createCartQuickRecommendation(pair, placement) {
    const row = document.createElement("div");
    row.className = "sx-cart-quick__item is-recommended";
    row.dataset.sxCartQuickItem = "";
    row.dataset.handle = pair.targetHandle;
    row.dataset.price = pair.priceLabel || "";
    this.applyCrossSellDataset(row, pair, placement);

    const link = document.createElement("a");
    link.href = pair.targetUrl;
    link.setAttribute(
      "aria-label",
      `${this.isNl ? "Bekijk" : "View"} ${pair.targetTitle}`,
    );
    const image = document.createElement("img");
    image.src = `${pair.targetImage}${String(pair.targetImage).includes("?") ? "&" : "?"}width=176`;
    image.alt = "";
    image.width = 88;
    image.height = 88;
    image.loading = "lazy";
    image.decoding = "async";
    link.append(image);

    const copy = document.createElement("span");
    copy.className = "sx-cart-quick__copy";
    const title = document.createElement("strong");
    title.textContent = pair.targetTitle;
    const detail = document.createElement("small");
    const price = document.createElement("span");
    price.dataset.sxCartQuickPrice = "";
    price.textContent = this.crossSellPriceText(pair);
    const reason = document.createElement("span");
    reason.dataset.sxCartQuickReason = "";
    reason.textContent = pair.reason ? ` · ${pair.reason}` : "";
    reason.hidden = !pair.reason;
    detail.append(price, reason);
    copy.append(title, detail);

    const button = document.createElement("button");
    button.type = "button";
    button.dataset.sxCartQuickadd = "";
    button.dataset.sxCommerceAvailable = "true";
    button.dataset.variantId = String(pair.targetVariantId);
    button.setAttribute(
      "aria-label",
      `${this.isNl ? "Voeg toe" : "Add"} ${pair.targetTitle}`,
    );
    button.textContent = "+";
    row.append(link, copy, button);
    return row;
  }

  renderCartRecommendationContainer(container, pair, placement) {
    if (!container) return;
    const previousId =
      container.querySelector("[data-sx-cart-quick-item]")?.dataset.sxRecommendationId || "";
    container.querySelectorAll("[data-sx-cart-quick-item]").forEach((row) => row.remove());
    if (!pair) {
      container.hidden = true;
      return;
    }

    const title = container.querySelector("[data-sx-cart-quick-title], .sx-cart-quick__title");
    if (title) title.textContent = this.isNl ? "Ook handig" : "Useful too";
    const row = this.createCartQuickRecommendation(pair, placement);
    container.append(row);
    container.hidden = false;
    if (
      pair.recommendationId !== previousId
      && !this.prefersReducedMotion
    ) {
      row.classList.add("is-new-recommendation");
      window.setTimeout(() => row.classList.remove("is-new-recommendation"), 700);
    }
  }

  renderProductRecommendation(cart = { items: [] }) {
    const container = document.querySelector("[data-sx-product-recommendation]");
    if (!container) return;

    const form = container.closest('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('[name="id"]');
    const sourceHandle = container.dataset.sourceHandle || "";
    const sourceVariantId = Number(variantInput?.value || container.dataset.sourceVariant || 0);
    const pair = this.crossSellPairForSource(sourceHandle, sourceVariantId);
    const cartHandles = new Set((cart?.items || []).map((item) => item.handle));
    container.replaceChildren();
    container.className = "";
    if (!pair || cartHandles.has(pair.targetHandle)) {
      container.hidden = true;
      return;
    }

    container.className = "sx-addon";
    container.dataset.sxAddon = "";
    container.dataset.sxCrossSellHandle = pair.targetHandle;
    container.dataset.sxCrossSellVariant = String(pair.targetVariantId);
    this.applyCrossSellDataset(container, pair, "product_page_addon");

    const label = document.createElement("label");
    label.className = "sx-addon__row";
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.dataset.sxAddonCheck = "";
    checkbox.dataset.sxAddonVariant = String(pair.targetVariantId);

    const media = document.createElement("span");
    media.className = "sx-addon__media";
    const image = document.createElement("img");
    image.src = `${pair.targetImage}${String(pair.targetImage).includes("?") ? "&" : "?"}width=220`;
    image.alt = pair.targetTitle;
    image.width = 180;
    image.height = 180;
    image.loading = "lazy";
    image.decoding = "async";
    media.append(image);

    const copy = document.createElement("span");
    copy.className = "sx-addon__copy";
    const title = document.createElement("strong");
    title.textContent = `${this.isNl ? "Voeg toe:" : "Add:"} ${pair.targetTitle}`;
    const detail = document.createElement("small");
    detail.textContent = [pair.reason, `+${this.crossSellPriceText(pair)}`]
      .filter(Boolean)
      .join(" · ");
    copy.append(title, detail);
    label.append(checkbox, media, copy);
    container.append(label);
    container.hidden = false;
  }

  renderCrossSellRecommendations(cart) {
    this._lastCart = cart;
    const pair = this.recommendationForCart(cart);
    this.renderCartRecommendationContainer(
      this.cartDrawer?.querySelector("[data-sx-cart-quick]"),
      pair,
      "cart_drawer",
    );
    this.renderCartRecommendationContainer(
      document.querySelector("[data-sx-cart-page-recommendation]"),
      pair,
      "cart_page",
    );
    this.renderProductRecommendation(cart);
    document.dispatchEvent(new CustomEvent("syvox:recommendations-updated"));
  }

  renderCart(cart) {
    if (!this.cartItems || !this.cartEmpty || !this.cartFooter) return;

    const itemCount = Number(cart.item_count || 0);
    const countGrew = typeof this._lastItemCount === "number" && itemCount > this._lastItemCount;
    this._lastItemCount = itemCount;
    document.querySelectorAll("[data-sx-cart-count]").forEach((counter) => {
      counter.textContent = itemCount;
      counter.hidden = itemCount === 0;
      if (countGrew && !this.prefersReducedMotion) {
        counter.classList.remove("sx-pop");
        void counter.offsetWidth;
        counter.classList.add("sx-pop");
        window.setTimeout(() => counter.classList.remove("sx-pop"), 650);
      }
    });
    document.querySelectorAll("[data-sx-cart-title-count]").forEach((counter) => {
      counter.textContent = `(${itemCount})`;
    });
    this.cartOpeners.forEach((opener) => {
      opener.setAttribute(
        "aria-label",
        this.isNl
          ? `Winkelwagen met ${itemCount} ${itemCount === 1 ? "product" : "producten"}`
          : `Cart with ${itemCount} ${itemCount === 1 ? "item" : "items"}`,
      );
    });

    this.cartItems.replaceChildren();
    cart.items.forEach((item) => {
      this.cartItems.append(this.createCartItem(item, cart.currency));
    });

    this.renderCrossSellRecommendations(cart);

    const hasItems = itemCount > 0;
    this.cartEmpty.hidden = hasItems;
    this.cartFooter.hidden = !hasItems;

    const hasUnavailableCommerce = this.cartHasUnavailableCommerce(cart);
    const subtotal = this.cartDrawer.querySelector("[data-sx-cart-subtotal]");
    if (subtotal) subtotal.textContent = this.formatMoney(cart.total_price, cart.currency);
    const subtotalRow = subtotal?.closest(".sx-cart-drawer__subtotal");
    if (subtotalRow) subtotalRow.hidden = false;
    const checkoutTotal = this.cartDrawer.querySelector("[data-sx-cart-checkout-total]");
    if (checkoutTotal) checkoutTotal.textContent = this.formatMoney(cart.total_price, cart.currency);
    const checkout = this.cartDrawer.querySelector("[data-sx-cart-checkout]");
    const commerceNotice = this.cartDrawer.querySelector("[data-sx-cart-commerce-notice]");
    if (checkout) {
      const checkoutBlocked = !hasItems || hasUnavailableCommerce;
      checkout.setAttribute("href", checkoutBlocked ? `${this.cartRoot()}cart` : `${this.cartRoot()}checkout`);
      checkout.setAttribute("aria-disabled", String(checkoutBlocked));
      checkout.classList.toggle("is-commerce-blocked", checkoutBlocked);
      checkout.hidden = checkoutBlocked;
    }
    if (commerceNotice) commerceNotice.hidden = !hasUnavailableCommerce;
    const shippingModule = this.cartDrawer.querySelector("[data-sx-cart-shipping]");
    if (shippingModule) shippingModule.hidden = false;
    const subtotalLabel = this.cartDrawer.querySelector(".sx-cart-drawer__subtotal span");
    if (subtotalLabel) {
      subtotalLabel.textContent = this.isNl ? "Producttotaal" : "Product subtotal";
    }

    const discountRow = this.cartDrawer.querySelector("[data-sx-cart-discount]");
    if (discountRow) {
      const saved = Number(cart.total_discount || 0);
      const hadDiscount = this._hadDiscount === true;
      const label = discountRow.querySelector("[data-sx-cart-discount-label]");
      const amount = discountRow.querySelector("[data-sx-cart-discount-amount]");
      if (saved > 0) {
        if (label) {
          label.textContent = this.isNl ? "Korting" : "Discount";
        }
        if (amount) amount.textContent = `−${this.formatMoney(saved, cart.currency)}`;
        discountRow.hidden = false;
        if (!hadDiscount && !this.prefersReducedMotion) {
          discountRow.classList.remove("is-new");
          void discountRow.offsetWidth;
          discountRow.classList.add("is-new");
          window.setTimeout(() => discountRow.classList.remove("is-new"), 1300);
        }
      } else {
        discountRow.hidden = true;
      }
      this._hadDiscount = saved > 0;
    }

    this.updateShippingProgress(cart.total_price, cart.currency);
  }

  highlightCartItem(variantId) {
    if (!variantId || !this.cartItems || this.prefersReducedMotion) return;
    const row = this.cartItems.querySelector(`[data-sx-cart-key^="${variantId}"]`);
    if (!row) return;
    row.classList.add("is-just-added");
    window.setTimeout(() => row.classList.remove("is-just-added"), 1300);
  }

  createCartItem(item, currency) {
    const itemDisplayTitle = item.product_title || (this.isNl ? "SYVOX-product" : "SYVOX product");
    const itemCommerceAvailable = this.isCommerceAvailableItem(item);
    const row = document.createElement("article");
    row.className = "sx-cart-drawer__item";
    row.dataset.sxCartItem = "";
    row.dataset.sxCartKey = item.key;
    row.dataset.sxCartQuantity = item.quantity;
    row.dataset.sxCartTitle = itemDisplayTitle;

    const media = document.createElement("a");
    media.className = "sx-cart-drawer__item-media";
    media.href = item.url;
    const itemImage = this.cartImageMap[item.handle] || item.image;
    if (itemImage) {
      const image = document.createElement("img");
      image.src = `${itemImage}${itemImage.includes("?") ? "&" : "?"}width=220`;
      image.alt = itemDisplayTitle || "SYVOX product";
      image.loading = "lazy";
      media.append(image);
    } else {
      const placeholder = document.createElement("span");
      placeholder.className = "sx-cart-drawer__item-placeholder";
      placeholder.textContent = "SYVOX";
      media.append(placeholder);
    }

    const copy = document.createElement("div");
    copy.className = "sx-cart-drawer__item-copy";
    const title = document.createElement("a");
    title.href = item.url;
    title.textContent = itemDisplayTitle;
    copy.append(title);

    if (!itemCommerceAvailable) {
      const commerceStatus = document.createElement("small");
      commerceStatus.className = "sx-cart-drawer__evidence-status";
      commerceStatus.textContent = this.commerceStatusMessageForItem(item);
      copy.append(commerceStatus);
    }

    if (item.variant_title && item.variant_title !== "Default Title") {
      const variant = document.createElement("small");
      variant.textContent = item.variant_title;
      copy.append(variant);
    }

    const controls = document.createElement("div");
    controls.className = "sx-cart-drawer__item-controls";
    const accessibleTitle = String(itemDisplayTitle || (this.isNl ? "product" : "product"))
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    controls.innerHTML = `
      <div class="sx-cart-drawer__quantity" role="group" aria-label="${this.isNl ? "Aantal voor" : "Quantity for"} ${accessibleTitle}">
        <button type="button" data-sx-cart-action="decrease" aria-label="${this.isNl ? "Verlaag aantal van" : "Decrease quantity of"} ${accessibleTitle}">−</button>
        <span>${item.quantity}</span>
        <button type="button" data-sx-cart-action="increase" aria-label="${this.isNl ? "Verhoog aantal van" : "Increase quantity of"} ${accessibleTitle}">+</button>
      </div>
      <button class="sx-cart-drawer__remove" type="button" data-sx-cart-action="remove" aria-label="${this.isNl ? "Verwijder" : "Remove"} ${accessibleTitle}">${this.isNl ? "Verwijderen" : "Remove"}</button>
    `;
    copy.append(controls);

    row.append(media, copy);
    const price = document.createElement("strong");
    price.className = "sx-cart-drawer__item-price";
    price.textContent = this.formatMoney(item.final_line_price, currency);
    row.append(price);
    return row;
  }

  updateShippingProgress(totalPrice, currency) {
    const threshold = 5500;
    const total = Number(totalPrice || 0);
    const remaining = Math.max(0, threshold - total);
    const percent = Math.min(100, (total / threshold) * 100);
    const module = this.cartDrawer?.querySelector("[data-sx-cart-shipping]");
    const title = this.cartDrawer?.querySelector("[data-sx-cart-shipping-title]");
    const text = this.cartDrawer?.querySelector("[data-sx-cart-shipping-text]");
    const track = this.cartDrawer?.querySelector("[data-sx-cart-shipping-track]");
    const bar = this.cartDrawer?.querySelector("[data-sx-cart-shipping-bar]");
    const unlocked = remaining === 0 && total > 0;

    if (title) {
      title.textContent = unlocked
        ? (this.isNl ? "Gratis NL-verzending bereikt ✓" : "Free Netherlands shipping reached ✓")
        : (this.isNl ? "Gratis NL-verzending vanaf €55" : "Free Netherlands shipping from €55");
    }
    if (text) {
      if (unlocked) {
        text.textContent = this.isNl
          ? "Gratis verzending is beschikbaar voor een Nederlands adres en wordt bevestigd bij het afrekenen."
          : "Free shipping is available for a Netherlands address and is confirmed at checkout.";
      } else if (total > 0) {
        text.textContent = this.isNl
          ? `Nog ${this.formatMoney(remaining, currency)} tot gratis verzending binnen Nederland.`
          : `${this.formatMoney(remaining, currency)} to free shipping within the Netherlands.`;
      } else {
        text.textContent = this.isNl
          ? "Gratis verzending binnen Nederland vanaf €55."
          : "Free shipping within the Netherlands from €55.";
      }
    }
    if (track) {
      track.setAttribute("aria-valuenow", String(Math.min(55, total / 100)));
      track.setAttribute(
        "aria-valuetext",
        unlocked
          ? (this.isNl ? "Grens voor gratis verzending bereikt" : "Free shipping threshold reached")
          : (this.isNl
            ? `Nog ${this.formatMoney(remaining, currency)} tot gratis verzending in Nederland`
            : `${this.formatMoney(remaining, currency)} remaining to free shipping in the Netherlands`),
      );
    }
    if (bar) bar.style.width = `${percent}%`;
    if (module) {
      module.classList.toggle("is-close", !unlocked && percent >= 70);
      module.classList.toggle("is-unlocked", unlocked);
      if (unlocked && this._shipUnlocked === false) this.celebrateShipping(module);
      this._shipUnlocked = unlocked;
    }
  }

  celebrateShipping(module) {
    this.burstConfetti(module);
  }

  burstConfetti(module) {
    if (this.prefersReducedMotion || !module) return;
    const old = module.querySelector(".sx-cart-confetti");
    if (old) old.remove();
    const burst = document.createElement("div");
    burst.className = "sx-cart-confetti";
    burst.setAttribute("aria-hidden", "true");
    const colors = ["#7547ff", "#9d7aff", "#2ecc71", "#ffd166", "#ffffff"];
    for (let i = 0; i < 26; i += 1) {
      const piece = document.createElement("i");
      const angle = (Math.random() * 150 + 15) * (Math.PI / 180);
      const distance = 60 + Math.random() * 110;
      piece.style.setProperty("--sx-cx", `${Math.cos(angle) * distance * (Math.random() > 0.5 ? 1 : -1)}px`);
      piece.style.setProperty("--sx-cy", `${-Math.sin(angle) * distance}px`);
      piece.style.setProperty("--sx-cr", `${Math.random() * 540 - 270}deg`);
      piece.style.background = colors[i % colors.length];
      piece.style.left = `${10 + Math.random() * 80}%`;
      piece.style.animationDelay = `${Math.random() * 120}ms`;
      burst.append(piece);
    }
    module.append(burst);
    window.setTimeout(() => burst.remove(), 1500);
  }

  formatMoney(cents, currency = "EUR") {
    // Match Shopify's storefront money format (€26,99) instead of the page locale,
    // so drawer prices and Liquid-rendered prices never mix separators.
    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency,
    })
      .format(Number(cents || 0) / 100)
      .replace(/ /g, "");
  }

  showCartError(message) {
    if (!this.cartError) return;
    this.cartError.textContent = message || (this.isNl ? "Er ging iets mis. Probeer het opnieuw." : "Something went wrong. Please try again.");
    this.cartError.hidden = false;
  }

  hideCartError() {
    if (this.cartError) this.cartError.hidden = true;
  }

  setupNewsletterCelebration() {
    const success = document.querySelector(".sx-footer__newsletter-success");
    if (!success || this.prefersReducedMotion || !("IntersectionObserver" in window)) return;
    success.style.position = "relative";
    const seen = { done: false };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || seen.done) return;
        seen.done = true;
        this.burstConfetti(success);
        observer.disconnect();
      });
    }, { threshold: 0.6 });
    observer.observe(success);
  }

  setupProductStory() {
    if (!this.productStory) return;

    const scene = this.productStory.querySelector("[data-sx-product-story-scene]");
    const steps = [...this.productStory.querySelectorAll("[data-sx-product-story-step]")];
    const kicker = this.productStory.querySelector("[data-sx-product-story-kicker]");
    const value = this.productStory.querySelector("[data-sx-product-story-value]");
    const label = this.productStory.querySelector("[data-sx-product-story-label]");

    if (!scene || !steps.length) return;

    const activate = (step) => {
      steps.forEach((item) => item.classList.toggle("is-active", item === step));
      scene.dataset.active = step.dataset.sxProductStoryStep || "power";
      if (kicker) kicker.textContent = step.dataset.kicker || "";
      if (value) value.textContent = step.dataset.value || "";
      if (label) label.textContent = step.dataset.label || "";
    };

    activate(steps[0]);

    if (this.prefersReducedMotion || !("IntersectionObserver" in window)) return;

    const storyObserver = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) activate(visible.target);
      },
      {
        rootMargin: "-36% 0px -36% 0px",
        threshold: [0, 0.2, 0.5, 0.8],
      },
    );

    steps.forEach((step) => storyObserver.observe(step));
  }
}

window.SyvoxExperience = Object.freeze({
  Experience: SyvoxExperience,
});

document.addEventListener("DOMContentLoaded", () => {
  new SyvoxExperience();
});
